import moment from 'moment'
import api from '../components/card/shared/components/note/shared/services/api'
import he from 'node_modules/he/he.js'

const state = {
  notes: []
}

// getters
const getters = {
  notes: state => {
    return state.notes
  }
}

// actions
const actions = {

  load ({ commit }, cardId) {
    api.getAllNotes(cardId)
      .then(payload => {
        commit('ADD_RANGE', payload.data)
      })
  },
  addNote ({ commit, rootGetters }, note) {
    let currUser = rootGetters['auth/loggedUserAsObj']
    commit('ADD', { id: note.id, user: currUser, desc: note.description })
  },
  updateNote ({ commit }, note) {
    commit('UPDATE_NOTE', note)
  },
  removeNote ({ commit }, noteId) {
    commit('REMOVE', noteId)
  }
}

// mutations
const mutations = {
  ADD (state, note) {
    let now = new Date()
    note.desc = he.unescape(note.desc)

    state.notes.splice(0, 0, {
      id: note.id,
      user: note.user,
      description: note.desc,
      editionPermited: true,
      creationDate: moment(now).format('DD/MM/YYYY HH:mm')
    })
  },
  ADD_RANGE (state, list) {
    list.forEach(each => {
      each.description = he.unescape(each.description)
    })

    state.notes = list
  },
  UPDATE_NOTE (state, note) {
    let oldNote = state.notes.find(find => find.id === note.id)
    oldNote.description = note.description
    oldNote.creationDate = note.creationDate
  },
  REMOVE (state, noteId) {
    let index = state.notes.findIndex(fIndex => fIndex.id === noteId)
    state.notes.splice(index, 1)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
